// eslint-disable-next-line import/prefer-default-export
export const isPercentage = value => /\d+%$/.test(value);